import { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useIdentifyAnalytics } from 'services/analytics/hooks/useIdentifyAnalytics';
import * as S from './Routes.style';
import { routes } from '../utils/constants/routes';
import { isLoggedInSelector, loginStatusSelector } from '../store/auth/auth.selectors';
import SentryErrorBoundary from '../services/sentry/components/SentryErrorBoundary';
import MissingEmailSocialLogin from './LoginMigrations/MissingEmailSocialLogin/MissingEmailSocialLogin';
import Login from './Login/Login';
import ActivateInvitationCallback from './Login/components/UserInvitation/ActivateInvitationCallback';
import ResolvedLogin from './Login/components/ResolvedLogin/ResolvedLogin';
import RiCloud from './RiCloud/RiCloud';
import { usePageViewTracking } from '../hooks/usePageViewTracking';

const MainWrapper = lazy(() => import('./MainWrapper/MainWrapper'));
const ICPFormMFE = lazy(() => import('../components/KycMFE/ICPFormMFE'));

const SocialLoginMigration = lazy(
  () => import('./LoginMigrations/SocialLoginMigration/SocialLoginMigration')
);

const SamlLoginMigration = lazy(
  () => import('./LoginMigrations/SamlLoginMigration/SamlLoginMigration')
);
const FreeTrial = lazy(() => import('./Marketplace/FreeTrial/FreeTrial'));
const AccountMapping = lazy(() => import('./Marketplace/AccountMapping/AccountMapping'));

const Routes = () => {
  useIdentifyAnalytics();
  usePageViewTracking();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const isLoginStatusResolved = useSelector(loginStatusSelector) === 'resolved';

  if (!isLoginStatusResolved) {
    return null;
  }

  return (
    <Suspense fallback={<S.Loader dataTestId="loader-routes-suspense" />}>
      <Switch>
        <Route exact path={routes.missingEmailSocialLogin} component={MissingEmailSocialLogin} />
        <Route exact path={routes.socialConfirmMigration} component={SocialLoginMigration} />
        <Route exact path={routes.samlConfirmMigration} component={SamlLoginMigration} />
        <Route exact path={routes.activateInvitation} component={ActivateInvitationCallback} />
        {isLoggedIn && (
          <Route exact path={routes.marketplaceAccountMapping} component={AccountMapping} />
        )}
        {isLoggedIn && <Route exact path={routes.marketplaceFreeTrial} component={FreeTrial} />}
        {isLoggedIn && <Route path={routes.riCloud} component={RiCloud} />}
        {isLoggedIn && <Route exact path={routes.icp.root} component={ICPFormMFE} />}
        {isLoggedIn ? (
          <MainWrapper />
        ) : (
          <SentryErrorBoundary errorArea="authentication">
            <Login />
          </SentryErrorBoundary>
        )}
      </Switch>
      {isLoginStatusResolved ? <ResolvedLogin /> : <div />}
    </Suspense>
  );
};

export default Routes;
